import moment from 'moment'
import { formatISK, formatUSD } from '../../utils'

// Shared display helpers for Áskell V2 subscription contracts
// (user.contract from /api/v3/core/user/current/).

export const formatAmount = (amount, currency) => {
  if (amount === null || amount === undefined || amount === '') {
    return ''
  }
  let value = parseFloat(amount)
  if (currency === 'ISK') {
    return `${formatISK(value)} kr.`
  }
  if (currency === 'USD') {
    return `$${formatUSD(value)}`
  }
  return `${value} ${currency || ''}`.trim()
}

export const intervalLabel = (interval, intervalCount) => {
  let count = parseInt(intervalCount || 1, 10)
  if (interval === 'year') {
    return count > 1 ? interpolate(gettext('every %s years'), [count]) : gettext('per year')
  }
  if (interval === 'week') {
    return count > 1 ? interpolate(gettext('every %s weeks'), [count]) : gettext('per week')
  }
  return count > 1 ? interpolate(gettext('every %s months'), [count]) : gettext('per month')
}

// "monthly" / "yearly": how often the subscriber is billed
export const intervalAdverb = (interval, intervalCount) => {
  let count = parseInt(intervalCount || 1, 10)
  if (count > 1) {
    return intervalLabel(interval, count)
  }
  if (interval === 'year') {
    return gettext('yearly')
  }
  if (interval === 'week') {
    return gettext('weekly')
  }
  return gettext('monthly')
}

export const formatDate = (value) => {
  if (!value) {
    return ''
  }
  return moment(value).format('D. M. YYYY')
}

export const contractStateLabel = (contract) => {
  if (!contract) {
    return ''
  }
  if (contract.is_active && contract.is_cancelled) {
    return gettext('Cancelled')
  }
  if (contract.is_active && contract.is_on_trial) {
    return gettext('Trial subscription')
  }
  if (contract.is_active) {
    return gettext('Active')
  }
  switch (contract.service_state || contract.state) {
    case 'past_due':
      return gettext('Payment overdue')
    case 'paused':
      return gettext('Paused')
    case 'ended':
    case 'canceled':
      return gettext('Ended')
    default:
      return gettext('Inactive')
  }
}

export const billingRunStateLabel = (state) => {
  switch (state) {
    case 'succeeded':
      return gettext('Paid')
    case 'failed':
      return gettext('Failed')
    case 'scheduled':
    case 'pending':
    case 'pending_external':
    case 'processing':
    case 'retrying':
    case 'retry_scheduled':
      return gettext('Pending')
    default:
      return state || ''
  }
}

// The date that matters most for the subscriber: when the next charge
// happens, or when access ends for cancelled / lapsed contracts.
export const contractExpiry = (contract) => {
  if (!contract) {
    return null
  }
  if (contract.is_cancelled) {
    return contract.cancel_at || contract.entitled_until || contract.next_billing_at
  }
  return contract.entitled_until || contract.next_billing_at
}
